import React from 'react';
import {
    Button,
    Col,
    Form,
    FormControl,
    InputGroup,
    Modal,
    Row
} from 'react-bootstrap';
import LineConfigViewModel from './LineConfig.viewmodel';

export default function LineConfig() {
    const {
        lineConfigs,
        editingIndex,
        editForm,
        setEditForm,
        handleStartEdit,
        handleCancelEdit,
        handleSaveEdit,
        showCreateForm,
        createForm,
        setCreateForm,
        handleOpenCreate,
        handleCancelCreate,
        handleSaveCreate
    } = LineConfigViewModel();

    return (
        <div>
            <div className="master-data-content">
                <div
                    className="trapezoid-head"
                    style={{ width: '200px' }}
                >
                    <span>Line Config</span>
                </div>

                <div className="mat-box">
                    <Row>
                        <Col>
                            <div className="container">
                                <div className="mb-3 flex items-center justify-between">
                                    <div
                                        className="trapezoid trapezoid-purple"
                                        style={{
                                            display: 'inline-block',
                                            width: 'fit-content'
                                        }}
                                    >
                                        <span>
                                            <i
                                                className="fa fa-search"
                                                aria-hidden="true"
                                            ></i>
                                            Line Config
                                        </span>
                                    </div>
                                    <Button
                                        variant="success"
                                        size="sm"
                                        onClick={handleOpenCreate}
                                    >
                                        <i
                                            className="fa fa-plus mr-1"
                                            aria-hidden="true"
                                        ></i>
                                        Add Config
                                    </Button>
                                </div>

                                <div className="divide-y border-x">
                                    <div className="flex bg-neutral-200">
                                        <div className="flex-1 py-1.5 text-center font-semibold">
                                            Config
                                        </div>
                                        <div className="flex-[2] py-1.5 text-center font-semibold">
                                            Content
                                        </div>
                                        <div className="w-24 py-1.5 text-center font-semibold">
                                            Action
                                        </div>
                                    </div>

                                    {lineConfigs?.map((lineConfig, index) => {
                                        const isEditing =
                                            editingIndex === index;
                                        return (
                                            <div
                                                key={index}
                                                className="flex gap-4 p-4"
                                            >
                                                <div className="flex-1">
                                                    <div className="flex w-full flex-col gap-1">
                                                        <InputGroup>
                                                            <Form.Group
                                                                className="w-full"
                                                                controlId={`lineConfig-${index}`}
                                                            >
                                                                <Form.Label>
                                                                    SID :
                                                                </Form.Label>
                                                                <FormControl
                                                                    className="w-full"
                                                                    placeholder="sid"
                                                                    value={
                                                                        lineConfig.sid
                                                                    }
                                                                    readOnly
                                                                />

                                                                <Form.Label className="mt-3">
                                                                    WF TYPE :
                                                                </Form.Label>
                                                                {isEditing ? (
                                                                    <FormControl
                                                                        className="w-full"
                                                                        placeholder="wftype"
                                                                        value={
                                                                            editForm.wftype ??
                                                                            ''
                                                                        }
                                                                        onChange={e =>
                                                                            setEditForm(
                                                                                {
                                                                                    ...editForm,
                                                                                    wftype: e
                                                                                        .target
                                                                                        .value
                                                                                }
                                                                            )
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <FormControl
                                                                        className="w-full"
                                                                        placeholder="wftype"
                                                                        value={
                                                                            lineConfig.wftype ??
                                                                            ''
                                                                        }
                                                                        readOnly
                                                                    />
                                                                )}

                                                                <Form.Label className="mt-3">
                                                                    WF CONDITION
                                                                    :
                                                                </Form.Label>
                                                                <FormControl
                                                                    className="w-full"
                                                                    placeholder="wfcondition"
                                                                    value={
                                                                        lineConfig.wfcondition
                                                                    }
                                                                    readOnly
                                                                />
                                                            </Form.Group>
                                                        </InputGroup>
                                                    </div>
                                                </div>

                                                <div className="flex-[2]">
                                                    <div className="flex w-full flex-col">
                                                        <Form.Label>
                                                            Content Body :
                                                        </Form.Label>
                                                        {isEditing ? (
                                                            <FormControl
                                                                as="textarea"
                                                                rows={6}
                                                                className="w-full font-mono text-sm"
                                                                value={
                                                                    editForm.contentbody ??
                                                                    ''
                                                                }
                                                                onChange={e =>
                                                                    setEditForm(
                                                                        {
                                                                            ...editForm,
                                                                            contentbody:
                                                                                e
                                                                                    .target
                                                                                    .value
                                                                        }
                                                                    )
                                                                }
                                                            />
                                                        ) : (
                                                            <div
                                                                className="prose w-full max-w-none text-sm"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: (
                                                                        lineConfig.contentbody ??
                                                                        ''
                                                                    )
                                                                        .split(
                                                                            '%NEW_LINE%'
                                                                        )
                                                                        .join(
                                                                            '<br>'
                                                                        )
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="flex w-24 flex-col gap-2 pt-6">
                                                    {isEditing ? (
                                                        <>
                                                            <Button
                                                                variant="primary"
                                                                size="sm"
                                                                onClick={
                                                                    handleSaveEdit
                                                                }
                                                            >
                                                                Save
                                                            </Button>
                                                            <Button
                                                                variant="danger"
                                                                size="sm"
                                                                onClick={
                                                                    handleCancelEdit
                                                                }
                                                            >
                                                                Cancel
                                                            </Button>
                                                        </>
                                                    ) : (
                                                        <Button
                                                            variant="warning"
                                                            size="sm"
                                                            onClick={() =>
                                                                handleStartEdit(
                                                                    index
                                                                )
                                                            }
                                                        >
                                                            Edit
                                                        </Button>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* Create modal */}
            <Modal
                show={showCreateForm}
                onHide={handleCancelCreate}
                size="lg"
            >
                <Modal.Header
                    closeButton
                    translate={undefined}
                >
                    <Modal.Title>Add Line Config</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group
                        className="mb-3"
                        controlId="create-sid"
                    >
                        <Form.Label>SID</Form.Label>
                        <FormControl
                            placeholder="sid"
                            value={createForm.sid}
                            onChange={e =>
                                setCreateForm({
                                    ...createForm,
                                    sid: e.target.value
                                })
                            }
                        />
                    </Form.Group>
                    <Form.Group
                        className="mb-3"
                        controlId="create-wfcondition"
                    >
                        <Form.Label>WF Condition</Form.Label>
                        <FormControl
                            placeholder="wfcondition"
                            value={createForm.wfcondition}
                            onChange={e =>
                                setCreateForm({
                                    ...createForm,
                                    wfcondition: e.target.value
                                })
                            }
                        />
                    </Form.Group>
                    <Form.Group
                        className="mb-3"
                        controlId="create-wftype"
                    >
                        <Form.Label>WF Type</Form.Label>
                        <FormControl
                            placeholder="wftype"
                            value={createForm.wftype ?? ''}
                            onChange={e =>
                                setCreateForm({
                                    ...createForm,
                                    wftype: e.target.value
                                })
                            }
                        />
                    </Form.Group>
                    <Form.Group
                        className="mb-3"
                        controlId="create-contentbody"
                    >
                        <Form.Label>Content Body</Form.Label>
                        <FormControl
                            as="textarea"
                            rows={6}
                            className="font-mono text-sm"
                            placeholder="content body (use %NEW_LINE% for line breaks)"
                            value={createForm.contentbody ?? ''}
                            onChange={e =>
                                setCreateForm({
                                    ...createForm,
                                    contentbody: e.target.value
                                })
                            }
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="danger"
                        onClick={handleCancelCreate}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="success"
                        onClick={handleSaveCreate}
                    >
                        Create
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
